/**
 * @author Adrian Judd <AngularJS@AdrianJudd.co.uk>
 */
angular
    .module('pitch.media')
    .factory('MediaFilter', ['config', '$resource', function (config, $resource) {
        return $resource(config.apiUri + '/media/filter/', {
            ids: '@ids'
        }, {
            request: {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson({
                        format: data.format,
                        subjects: data.subjects.map(function (subject) {
                            return subject.id;
                        })
                    });
                }
            }
        });
    }]);



// WEBPACK FOOTER //
// ./src/MediaClientBundle/Resources/js/angular/services/MediaFilter.js